<template>
  <modal @close="$emit('close')">
    <div slot="header">
      <h4>{{ lead.ref_id }} - Send SMS booking link</h4>
    </div>
    <div slot="body">
      <div class="row mb-2">
        <div class="col-12">
          <div class="select-wrap">
            <label>Choose from template</label>
            <simple-select v-model="followUp.template"
                           :options="followUp.emailTemplates"
                           placeholder="Select template"
                           @input="loadEmailTemplate"
            />
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <div class="select-wrap h-auto">
            <label>SMS body</label>
            <textarea ref="ta" name="" id="" cols="30" rows="10" class="select-wrap-textarea form-control"
                      v-model="followUp.body"
                      @click="addingVariableOn = 'ta'"
            />
          </div>
          <error-field :errors="errors" field="body" />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <div>
            <span class="badge badge-primary mx-1 unselectable pointer"
                  v-for="(variable, key, index) in followUp.variables"
                  :key="index" @dblclick="insertVariable(variable)"
            >{{ key }}</span>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-right">
          <button class="btn btn-primary w-100 ld-ext-right"
                  type="button"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
                  @click="sendSMS(lead.id)"
          >
            Send SMS
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
    </div>
    <div slot="footer" />
  </modal>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';
import Modal from '../../Modal';

const initialBody = `
Here's your booking link: {{booking_link}}

{{company_name}}
`;

export default {
  components: {
    Modal,
    ErrorField,
  },
  props: {
    lead: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    buttonDisabled: false,
    loadingButton: false,
    errors: new Errors(),
    customer_email_selected: '',
    customerContactsWithEmail: null,
    addingVariableOn: 'subject',
    followUp: {
      body: initialBody,
      subject: 'Book your move on Mod24!',
      template: '',
      emailTemplates: [],
      type_id: 0,
      notes: '',
      variables: [],
    },
  }),
  mounted() {
    this.getContacts();
    this.getEmailTemplates();
    this.loadVariables();
  },
  methods: {
    sendSMS(id) {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .post(`/leads/${id}/booking-sms`, {
          body: this.followUp.body,
          type: 'sms',
        })
        .then(() => {
          toastr.success('Successfully sent booking link');
          this.$emit('load');
          this.$emit('close');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    getEmailTemplates() {
      axios
        .get('/lead-follow-up-email-templates')
        .then(res => {
          this.followUp.emailTemplates = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    loadEmailTemplate() {
      this.followUp.body = this.swapVariables(
        this.followUp.emailTemplates.find(temp => temp.id === this.followUp.template).body,
      );
      this.followUp.subject = this.swapVariables(
        this.followUp.emailTemplates.find(temp => temp.id === this.followUp.template).subject,
      );
    },
    loadVariables() {
      axios
        .get(`lead-follow-up-email-templates/leads/${this.lead.id}/values`)
        .then(res => {
          this.followUp.variables = res.data;
          this.followUp.body = this.swapVariables(this.followUp.body);
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getContacts() {
      axios.get(`/customers/${this.lead.customer.id}/contacts`).then(res => {
        const contacts = res.data.data;
        this.customerContactsWithEmail = contacts.filter(el => el.email !== undefined);
        if (!this.customerContactsWithEmail.find(el => el.email === this.lead.customer.email)) {
          this.customerContactsWithEmail.push({
            customer_id: this.lead.customer.id,
            email: this.lead.customer.email,
            id: '',
            phone: '',
          });
        }
      });
    },
    insertVariable(variable) {
      const textarea = this.addingVariableOn === 'subject' ? this.$refs.subject : this.$refs.ta;
      const cursorPosition = textarea.selectionStart;
      const textBefore = textarea.value.substring(0, cursorPosition);
      const textAfter = textarea.value.substring(cursorPosition, textarea.value.length);
      textarea.value = textBefore + variable + textAfter;
      if (this.addingVariableOn === 'subject') {
        this.followUp.subject = textarea.value;
      } else {
        this.followUp.body = textarea.value;
      }
      if (textarea.setSelectionRange) {
        textarea.focus();
        textarea.setSelectionRange(
          cursorPosition + variable.length,
          cursorPosition + variable.length,
        );
      }
    },
    swapVariables(text) {
      return text.replace(/\{\{(.*?)\}\}/g, (match, string) => this.followUp.variables[string]);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/leads/bokingLink/BookingLinkSMSModal.vue